export default "__VITE_ASSET__Bm3cl_km__"